import { render } from "./appView.vue?vue&type=template&id=19e68d52&scoped=true"
import script from "./appView.vue?vue&type=script&lang=js"
export * from "./appView.vue?vue&type=script&lang=js"

import "./appView.vue?vue&type=style&index=0&id=19e68d52&lang=css"
import "./appView.vue?vue&type=style&index=1&id=19e68d52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e68d52"]])

export default __exports__